export default "skymp5-front/782088b1d2fed2ebb51efb5bf265f051.jpg";